import React, { Component } from 'react';
import { connect } from "react-redux";
import actions from 'store/actions';
import { DataTagHistoryList, LoadingOverlay, FullHeightContainerLayout } from "components";
import { showError } from 'common/ToastNotifications';
import { withRouter } from "react-router";
import _ from 'lodash';
import { Row, Col, Typography, Empty } from 'antd';

const { Title, Text } = Typography;

class EventDataTag extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fetchingData: true
        }
    }

    componentWillMount() {
        if (!this.props.itemOperation) {
            this.setState({
                busy: true,
                busyMessage: "Getting data tag...",
            });
            this.props.getEventDataTag(this.props.eventId, this.props.tagId);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetEventDataTagResultUpdate(prevProps);
    }

    onGetEventDataTagResultUpdate = (prevProps) => {
        if (this.props.getEventDataTagResult && this.props.getEventDataTagResult !== prevProps.getEventDataTagResult) {
            if (!this.props.getEventDataTagResult.success) {
                if (this.props.getEventDataTagResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true
                    });
                }
                else {
                    showError("Unable to get data tag at this moment.");
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingData: false
            });
        }
    }

    isBusy = () => {
        let isBusy = (this.state.busy || this.state.fetchingData);
        return isBusy;
    }

    render() {
        return (
            <>
                {
                    this.isBusy()
                        ?
                        <LoadingOverlay
                            busy={true}
                            spinner
                            message={this.state.busyMessage || "Please wait..."}>
                        </LoadingOverlay>
                        :
                        <></>
                }
                {
                    !this.state.fetchingData
                        ?
                        <FullHeightContainerLayout
                            showHeader={true}
                            showFooter={false}
                            header={<Title level={5}><Text>Event Revision - </Text><Text type="secondary" italic>{`(Data tag: ${this.props.tagName})`}</Text></Title>}
                            content={this.props.dataTagRevision ?
                                <DataTagHistoryList
                                    dataTagRevisions={[this.props.dataTagRevision]}>
                                </DataTagHistoryList>
                                :
                                <Empty></Empty>}>
                        </FullHeightContainerLayout>
                        :
                        <></>
                }
            </>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getEventDataTagResult: state.eventDataTag.getEventDataTagResult,
        dataTagRevision: state.eventDataTag.dataTagRevision
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getEventDataTag: (eventId, tagId) => dispatch(actions.getEventDataTagRequest(eventId, tagId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EventDataTag));